<!-- Migrated from legacy/Plus/Plus/2017/Events/index.shtml ("2015 Events" section) -->

<template>
  <h3><span style="font-weight: 200">'Science Reimagined'</span></h3>
  <h4>7pm, Sunday 7 June 2015 &mdash; Charles Perkins Centre Auditorium, University of Sydney</h4>
  <p>
    Today's high school biology students will be tomorrow's scientists, explorers, and
    environmental policy makers. To prepare them for their work, a team led by naturalist E.O.
    Wilson created the iBook series 'Life on Earth'. Presented by VizbiPlus, this event brought
    scientific animator <strong>Ga&euml;l McGill</strong>, who led a team of 3D animators and
    multimedia artists, to Sydney, to show how they created the multimedia components of this
    revolutionary iBook &mdash; a digital textbook for the 21st century.
  </p>
  <img class="banner" src="/Showcase/2015.jpg" alt="VIZBI Showcase 2015 hero image" />
  <div class="videoWrapper">
    <iframe
      src="https://www.youtube.com/embed/Fb8XvwBipMU"
      title="Science Reimagined"
      frameborder="0"
      allowfullscreen/>
  </div>
  <p>
    Next in the program was the Sydney premiere of the latest biomedical animations from the
    Australia-based VizbiPlus project, followed by the finalists in the VizbiPlus Challenge
    &mdash; mixing artwork inspired by science with science re-imagined as art &mdash; and
    30-second flash-talks from participants whose own work bridges art and science.
  </p>
  <img
    class="portrait right"
    src="/Showcase/2015/GaelMcGill.jpg"
    alt="Portrait of Gaël McGill" />
  <p><strong>About Ga&euml;l McGill, Ph.D.</strong> (President &amp; CEO, Digizyme)</p>
  <p>
    Driven by a passion for the visualization and communication of science, Ga&euml;l co-founded
    Digizyme while a research fellow at the Dana-Farber Cancer Institute and Harvard Medical
    School. Ga&euml;l is Director of Molecular Visualization at Harvard Medical School, where he
    also teaches scientific visualization. He is the creator of the online portal
    molecularmovies.org and the Molecular Maya software toolkit, and the Digital Media Director
    for E.O. Wilson's 'Life on Earth' next-generation digital biology textbook.
  </p>
  <h4>Data Visualization Masterclass</h4>
  <img
    class="masterclass left"
    src="/Showcase/2015/DataVisMasterclass.jpg"
    alt="Data Visualization Masterclass" />
  <p>
    2015 was the third year of VizbiPlus involvement in Vivid Ideas, part of
    <a href="https://www.vividsydney.com">Vivid Sydney</a> (22 May &ndash; 8 June), an 18-day
    festival of light, music and ideas &mdash; the largest of its kind in the Southern
    Hemisphere. The Vivid Ideas event <em>Data Visualization Masterclass: principles, tools and
      storytelling</em> &mdash; with Ga&euml;l McGill, Tamara Munzner, and others &mdash; offered
    a unique opportunity to learn new skills for anyone working with data
    (<a href="https://datavismasterclass.org/2015/">program</a>).
  </p>
  <h4>VizbiPlus Animation Premiere</h4>
  <p class="date">
    4:30&ndash;5:45pm, Wednesday 4 February 2015 &mdash; CSIRO Discovery Centre, Canberra
  </p>
  <div class="videoWrapper">
    <iframe
      src="https://www.youtube.com/embed/DmKfS5gvyaU"
      title="VizbiPlus Animation Premiere webcast"
      frameborder="0"
      allowfullscreen/>
  </div>
  <a
    href="/Showcase/2015/CanberraInvite-lg.jpg"
    title="Top: still from Christopher Hammang's 'Alzheimer's Enigma'; bottom: still from Maja
      Divjak's 'The Insulin Receptor and Type 2 Diabetes'">
    <img
      class="invite right"
      src="/Showcase/2015/CanberraInvite.jpg"
      alt="Canberra Premiere Invite" />
  </a>
  <p>
    Christopher Hammang's <strong>"Alzheimer's Enigma"</strong> explores the neurons of the human
    brain, and reveals how normal protein breakdown processes become dysfunctional and result in
    plaque formation during Alzheimer's disease. Maja Divjak's <strong>"The Insulin Receptor and
      Type 2 Diabetes"</strong> tells a story about diabetes focusing on the insulin receptor
    structure and what might be happening in insulin resistance, based on pioneering research at
    the Walter and Eliza Hall Institute.
  </p>
  <p>
    Speakers included Prof. Ian Chubb (Chief Scientist of Australia), Dr. Jim Peacock (CSIRO),
    Dr. Se&aacute;n O'Donoghue (CSIRO &amp; Garvan Institute), Drew Berry (WEHI), Dr. Bill Wilson
    (CSIRO), Dr. Mike Lawrence (WEHI), Dr. Maja Divjak (WEHI), and Christopher Hammang (Garvan
    Institute). For speaker bios, see the
    <a href="/Showcase/2015/Invite4Feb2015.pdf">2015 VizbiPlus Animation Premiere brochure</a>.
  </p>
</template>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 1.5rem;
  clear: both;
}
p.date {
  color: var(--subtitle-color);
  font-weight: 600;
}
img.banner {
  width: 100%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 1rem;
}
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  margin-bottom: 1rem;
  clear: both;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
img.portrait,
img.invite {
  max-width: 35%;
  border-radius: 4px;
}
img.masterclass {
  max-width: 45%;
  border-radius: 4px;
}
img.right {
  float: right;
  margin: 0 0 1rem 1.5rem;
}
img.left {
  float: left;
  margin: 0 1.5rem 1rem 0;
}
</style>
